<template>
  <div class="pt-3">
    <jodit-editor v-model="contents" :setConfigs="setConfigs" />
    <v-layout justify-end mt-3>
      <v-btn :loading="loading" :disabled="loading" class="registration" @click="submitTicket()">登録</v-btn>
    </v-layout>
  </div>
</template>

<script>
import eventBus from '@/event_bus'
import eventType from '@/components/menus/ticket/enums/eventType'

export default {
  name: 'ticket_incident_memo',
  props: {
    ticketId: {
      type: Number
    },
    ticketAgentId: {
      type: Number
    }
  },
  data () {
    return {
      loading: false,
      contents: '',
      setConfigs: {
        buttons: ['bold', 'strikethrough', 'underline', 'italic', 'paragraph', 'font', 'fontsize', 'brush', 'ul', '|', 'image', 'file'],
        configs: {
          imageDefaultWidth: 100,
          minHeight: 200,
          toolbarButtonSize: 'small',
          showCharsCounter: false,
          i18n: {
            ko: {
              'Type something': 'メッセージを入力してください。',
              'Bold': '太字',
              'Drop image': 'ファイルをここに置くか',
              'Drop file': 'ファイルをここに置くか',
              'or click': 'クリックしてください'
            }
          }
        }
      }
    }
  },
  methods: {
    submitTicket () {
      if (this.loading === false) {
        this.loading = true
        if (this.contents.trim().length <= 0) {
          this.loading = false
          this.$alertMsg('スペースは入力できません。')
          return
        }
        if (!this.ticketId) {
          this.loading = false
          this.$alertMsg('正常ではない経路です。')
          return
        }
        this.axios.post(`/gateway/ticket/${this.ticketId}/incident/create`, {
          eventCode: 1101,
          content: this.contents,
          agentId: this.ticketAgentId
        }).then(result => {
          if (result.data.code === 0) {
            this.$alertMsg('イベントが登録されました。')
          } else {
            this.$alertMsg(result.data.message)
          }
        }).then(() => this.fetchIncidentList())
          .finally(() => {
            this.loading = false
          })
      }
    },
    fetchIncidentList () {
      this.contents = ''
      eventBus.$emit(eventType.FETCH_INCIDENT_LIST)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/fragments/ticket_incident_memo.vue